import { Box } from "@mui/system";
import { DonutChart } from "bizcharts";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import DownloadButton from "../Common/DownloadButton";

const RingChart = (props) => {
    const [data, setData] = useState([]);

    const csv = props.csv;
    const { readString } = usePapaParse();

    const handleReadString = () => {
        readString(csv, {
            complete: (results, file) => {
                setData(results.data);
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    };

    useEffect(() => {
        handleReadString();
    }, []);

    const [canvas, setCanvas] = useState(undefined);


    return (
        <Box display='flex' sx={{ maxWidth: '700px', width: '90%' }} flexDirection='column'>
            <Box display="flex">
                <p style={{ width: '100%', marginBottom: '1.1rem', fontFamily: 'Roboto Condensed, sans-serif' }}>no. of quantified residues per sample</p>
                <DownloadButton canvas={canvas} fileName='no. of quantified residues per sample' csv={data} isRaw />
            </Box>
            <DonutChart
                data={data.filter(d => d['Food commodity'] === props.filter) || []}
                autoFit
                forceFit
                radius={0.8}
                interactions={[{
                    type: 'element-selected',
                    enable: true,
                }]}
                legend={{
                    visible: false
                }}
                label={{
                    type: 'outer',
                    formatter: (angleField, colorField) => {
                        return ['value', angleField['Number of quantifications'] + ' ' + angleField['EUCP samples'] + ' (' + angleField['Proportion per food commodity'] + '%)'];
                    },
                    style: {
                        fontFamily: 'Roboto Condensed, sans-serif'
                    }
                }}
                statistic={{
                    title: false,
                    content: false
                }}
                tooltip={{
                    itemTpl: '<li style="padding: 10px 0" data-index={index}>'
                        + '<span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>'
                        + '{name}: {value}%'
                        + '</li>'
                }}
                padding="auto"
                angleField="Proportion per food commodity"
                colorField="Number of quantifications"
                color='#FFBB00'
                pieStyle={{ stroke: "white", lineWidth: 1 }}
                onGetG2Instance={chartInstance => {
                    setCanvas(chartInstance.chart.canvas);
                }}
            />
        </Box >
    );
}

export default RingChart;